const getCountryData = (countries, country) => {
  const countryData = countries?.filter(
    cnty => cnty?.id?.toString() === country?.toString()
  )
  return countryData?.[0]
}

export default getCountryData
